export { default } from './CourseList.jsx'
